import { createFileRoute } from "@tanstack/react-router";

import { enrolmentSearchParamsSchema } from "@/domain/enrolment";
import { RegistrationsScreen } from "@/interactors/RegistrationsScreen";
import { headWithCustomTitle } from "@/utils/router";

export const Route = createFileRoute("/_authed/admin/registrations/")({
  component: RegistrationsScreen,
  head: () => headWithCustomTitle("main:registrations.title"),
  validateSearch: enrolmentSearchParamsSchema,
});
